import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { FolderOpen, Upload, FileText } from "lucide-react";
import { DOCUMENTS } from "../demoData";
import { Card, CardHead, PageTitle, Badge, Btn } from "../ui";

export default function Documents() {
  const [docs, setDocs] = useState(DOCUMENTS);
  const ref = useRef(null);
  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setDocs((d) => [{ name: f.name, type: "Upload", status: "Pending", date: "Just now" }, ...d]);
    toast.success(`${f.name} uploaded for review (demo — not saved)`);
    e.target.value = "";
  };
  return (
    <>
      <PageTitle title="Documents" sub="Tax forms, agreements and ad proof screenshots."
        right={<><input ref={ref} type="file" className="hidden" onChange={onFile} data-testid="docs-file-input" /><Btn onClick={() => ref.current?.click()} data-testid="docs-upload-btn"><Upload className="w-4 h-4" />Upload Document</Btn></>} />
      <Card testId="docs-list">
        <CardHead icon={FolderOpen} title={`${docs.length} documents`} />
        <div className="divide-y divide-slate-800">
          {docs.map((d, i) => (
            <div key={`${d.name}-${i}`} className="flex items-center gap-4 px-5 py-4" data-testid={`doc-row-${i}`}>
              <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center flex-shrink-0"><FileText className="w-5 h-5 text-blue-400" /></div>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-white truncate">{d.name}</p>
                <p className="text-xs text-slate-500">{d.type} · {d.date}</p>
              </div>
              <Badge>{d.status}</Badge>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
}
